<template>
  <b-form-row offset="offset">
    <b-col>
      <check-field ref="field" :item="item" v-if="item.field.entry_type === 'check'" v-on:change="checkChange"></check-field>
      <single-line-text-field ref="field" :item="item" v-else-if="item.field.entry_type === 'string' && !item.field.multiline"></single-line-text-field>
      <multi-line-text-field ref="field" :item="item" v-else-if="item.field.entry_type === 'string' && item.field.multiline"></multi-line-text-field>
      <decimal-field ref="field" :item="item" v-else-if="item.field.entry_type === 'decimal'"></decimal-field>
      <date-field ref="field" :item="item" v-else-if="item.field.entry_type === 'date'"></date-field>
      <select-list-field ref="field" :item="item" v-else-if="item.field.entry_type === 'select_list'"></select-list-field>
      <p v-else="true">{{item.prompt}}</p>
      <data-entry-field v-for="(subItem, subItemIndex) in item.items" :key="subItemIndex" v-if="item.value" ref="subFields"
                        :item="subItem" :offset="offset + 1" v-on:check-change="checkChange">
      </data-entry-field>
    </b-col>
  </b-form-row>
</template>


<script>
import CheckField from '@/components/data_entry/CheckField'
import SingleLineTextField from '@/components/data_entry/SingleLineTextField'
import MultiLineTextField from '@/components/data_entry/MultiLineTextField'
import DecimalField from '@/components/data_entry/DecimalField'
import DateField from '@/components/data_entry/DateField'
import SelectListField from '@/components/data_entry/SelectListField'
import _ from 'lodash'

export default {
  name: 'DataEntryField',
  components: {
    'check-field': CheckField,
    'single-line-text-field': SingleLineTextField,
    'multi-line-text-field': MultiLineTextField,
    'decimal-field': DecimalField,
    'date-field': DateField,
    'select-list-field': SelectListField
  },
  props: {
    item: { type: Object },
    offset: { type: Number, default: 0 }
  },
  computed: {
  },
  methods: {
    checkChange (details, event) {
      this.$emit('check-change', details)
    },
    validate () {
      var isValid = this.$refs.field.validate()
      if (this.$refs.subFields != null) {
        this.$refs.subFields.forEach((f) => { isValid = f.validate() && isValid })
      }
      return isValid
    },
    values () {
      var values = [this.$refs.field.value()]
      if (this.$refs.subFields != null) {
        this.$refs.subFields.forEach((f) => { values = _.concat(values, f.values()) })
      }
      return values
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data_entry/DataEntryField.vue